angular.module("smartorg.r6.navs.reportOptions", []).directive("select", function () {
    return {
        restrict: "E",
        require: "?ngModel",
        scope: false,
        link: function (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }
            /**
             * Bind arrow key up and down for &lt;select&gt;.
             */
            element.bind("keyup", function () {
                element.triggerHandler("change");
            });
        }
    };
});
require('bootstrap');
require('../logic/report-option-errors');
require('../logic/report-option-tags');
require('./compare-to-directive');
require('./filter-directive');
require('./option-header-directive');
require('./report-options-directive');
require('../../css/app.css');
module.exports = 'smartorg.r6.navs.reportOptions';
//# sourceMappingURL=app.js.map


// WEBPACK FOOTER //
// ./app/widgets/navigation/report-options/app/js/plumbing/app.js